<script setup lang="ts">
import emblaCarouselVue from "embla-carousel-vue";
import emblaCarouselAutoplay from "embla-carousel-autoplay";

const [emblaRef, emblaApi] = emblaCarouselVue({ loop: true, container: ".embla-container" }, [emblaCarouselAutoplay({ delay: 10000 })]);
const curSlide = ref(0);
onMounted(() => {
  emblaApi.value?.on("select", () => {
    curSlide.value = emblaApi.value?.selectedScrollSnap() || 0;
  });
});
</script>

<template>
  <div ref="emblaRef" class="ui-slider relative overflow-hidden">
    <div class="embla-viewport">
      <div class="embla-container">
        <slot />
      </div>
    </div>
    <div v-if="(emblaApi?.slideNodes().length || 0) > 1" class="embla-dots">
      <button
        v-for="(slide, i) in emblaApi?.slideNodes()" :key="i"
        class="size-4 rounded-full transition" :class="curSlide === i ? 'bg-primary':'bg-white/50 hover:bg-white'"
        @click="emblaApi?.scrollTo(i)"
      />
    </div>
  </div>
</template>

<style lang="postcss">
.embla-container {
  @apply flex;
  &>* {
    @apply flex-none w-full min-w-0;
  }
}
.embla-dots {
  @apply absolute inset-x-0 bottom-6 flex justify-center items-center gap-3;
}
</style>
